// extracted by mini-css-extract-plugin
module.exports = {"submitButtonWithProgress":"styles_submitButtonWithProgress__2C37L","standardWidth":"styles_standardWidth__2B9td","fullWidth":"styles_fullWidth__3Lp0d"};